import { SyntheticEvent, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { cancelFacultyAccountVerification } from '../../auth/store/actions';
import { selectAuthSession, selectIsProvisionalAccount } from '../../auth/store/selectors';
import { LayoutContext } from '../../shared/Layout/Context';
import { useAppSelector } from '../../store/hooks';
import { useRequestDispatch } from '../../utils/request-actions';
import { setHomeActiveTab } from '../store/actions';
import { selectHomeActiveTab } from '../store/selectors';
import { HomeTabs } from '../store/types';

export const HomeTabIds = {
  [HomeTabs.ONGOING_COURSES]: 'home-ongoing-courses-tab',
  [HomeTabs.PAST_COURSES]: 'home-past-courses-tab',
};

export const HomeTabPanelIds = {
  [HomeTabs.ONGOING_COURSES]: 'home-ongoing-courses-tabpanel',
  [HomeTabs.PAST_COURSES]: 'home-past-courses-tabpanel',
};

export default function useHomeHeaderVM() {
  const dispatch = useDispatch();
  const requestDispatch = useRequestDispatch();

  const session = useAppSelector((state) => selectAuthSession(state));
  const isProvisionalAccount = useAppSelector((state) => selectIsProvisionalAccount(state));
  const university = session?.university.name || 'university';

  const { setSelectedTabIds } = useContext(LayoutContext);

  const handleCancelAccountVerification = async () => {
    await requestDispatch(cancelFacultyAccountVerification);
  };

  /** active tab */

  const activeTab = useAppSelector((state) => selectHomeActiveTab(state));

  const handleChangeActiveTab = (event: SyntheticEvent<Element, Event>, value: HomeTabs) => {
    dispatch(setHomeActiveTab({ tab: value }));
  };

  useEffect(
    function onMount() {
      return function cleanup() {
        setSelectedTabIds(null);
      };
    },
    [setSelectedTabIds]
  );

  useEffect(
    function onActiveTabChange() {
      setSelectedTabIds({
        tabId: HomeTabIds[activeTab],
        panelId: HomeTabPanelIds[activeTab],
      });
    },
    [setSelectedTabIds, activeTab]
  );

  return {
    handleCancelAccountVerification,
    isProvisionalAccount,
    university,
    activeTab,
    handleChangeActiveTab,
  };
}
